import { Box, Typography, useTheme } from '@mui/material';
import { AgentPage } from '@pages/Admin/Main';
import { IconHeadphones } from '@shared/assets/images/svgs';
import { AgentDto } from '@shared/services/apiService/apiService';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface AgentTabProps {
  agents: AgentDto[];
  isLoading: boolean;
  refetch: () => Promise<void>;
  onAgentCreated: () => Promise<void>;
  isProductDetailsDirty: boolean;
  isSavingProductDetails: boolean;
  onProductDetailsSave: () => Promise<boolean>;
  onProductDetailsCancel: () => void;
  productDetailsRevision: number;
  onEditorDirtyChange?: (dirty: boolean) => void;
}

const AgentTab: FC<AgentTabProps> = ({
  agents,
  isLoading,
  refetch,
  onAgentCreated,
  isProductDetailsDirty,
  isSavingProductDetails,
  onProductDetailsSave,
  onProductDetailsCancel,
  productDetailsRevision,
  onEditorDirtyChange,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box width="100%" padding={4}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
          'svg path': {
            stroke: theme.palette.getContrastText(theme.palette.background.default),
          },
        }}>
        <IconHeadphones />
        <Typography fontSize="18px" fontWeight={600}>
          {t('campaignPage.agents')}
        </Typography>
      </Box>
      <AgentPage
        agents={agents}
        isLoading={isLoading}
        refetch={refetch}
        onAgentCreated={onAgentCreated}
        isProductDetailsDirty={isProductDetailsDirty}
        isSavingProductDetails={isSavingProductDetails}
        onProductDetailsSave={onProductDetailsSave}
        onProductDetailsCancel={onProductDetailsCancel}
        productDetailsRevision={productDetailsRevision}
        onEditorDirtyChange={onEditorDirtyChange}
      />
    </Box>
  );
};

export default AgentTab;
